const projects = [
    {
        title: 'Microservices with JWT Authentication',
        description: 'Microservices architecture using Eureka, Hystrix, Feign Client, and RestTemplate.',
        tech: 'JWT, Eureka, Hystrix, Feign Client, RestTemplate',
        year: '2025',
        // image: img1,
        link: '#'
    },
    {
        title: 'React E-Commerce App',
        description: 'An online store built with React, Redux, and Firebase for auth and storage.',
        tech: 'React, Redux, Firebase',
        year: '2024',
        // image: img2,
        link: '#'
    },
    // Add more projects as needed
];

export default projects;
